"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBookingComponent;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _AppContainer = _interopRequireDefault(require("./AppContainer"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var _TrackingParams = _interopRequireDefault(require("MeetingsLib/models/TrackingParams"));

var _createStore = require("MeetingsLib/utils/createStore");

function createBookingComponent(_ref) {
  var _ref$httpClient = _ref.httpClient,
      httpClient = _ref$httpClient === void 0 ? _apiClient.default : _ref$httpClient,
      _ref$embedded = _ref.embedded,
      embedded = _ref$embedded === void 0 ? true : _ref$embedded,
      slug = _ref.slug,
      _ref$formState = _ref.formState,
      formState = _ref$formState === void 0 ? {} : _ref$formState,
      forceOffline = _ref.forceOffline,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? _I18n.default.moment.tz.guess() : _ref$timezone,
      _ref$initTrackingForM = _ref.initTrackingForMeetings,
      initTrackingForMeetings = _ref$initTrackingForM === void 0 ? true : _ref$initTrackingForM,
      _ref$trackingParams = _ref.trackingParams,
      trackingParams = _ref$trackingParams === void 0 ? {} : _ref$trackingParams,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      locale = _ref.locale,
      forceMobile = _ref.forceMobile,
      _ref$parentPageHSAnal = _ref.parentPageHSAnalyticsInfo,
      parentPageHSAnalyticsInfo = _ref$parentPageHSAnal === void 0 ? {} : _ref$parentPageHSAnal,
      _ref$troubleshooting = _ref.troubleshooting,
      troubleshooting = _ref$troubleshooting === void 0 ? false : _ref$troubleshooting,
      _ref$forcePropertyFor = _ref.forcePropertyForm,
      forcePropertyForm = _ref$forcePropertyFor === void 0 ? null : _ref$forcePropertyFor,
      _ref$allowTroubleshoo = _ref.allowTroubleshootMode,
      allowTroubleshootMode = _ref$allowTroubleshoo === void 0 ? false : _ref$allowTroubleshoo,
      _ref$allowRedirect = _ref.allowRedirect,
      allowRedirect = _ref$allowRedirect === void 0 ? false : _ref$allowRedirect,
      disabledHsPopups = _ref.disabledHsPopups;

  var formStateFromParams = _FormState.default.from(formState);

  var store = (0, _createStore.createStore)({
    userSlug: slug,
    embedded: embedded,
    forceOffline: forceOffline,
    trackingParams: new _TrackingParams.default(trackingParams),
    initialFormState: formStateFromParams,
    stagedFormState: formStateFromParams,
    formState: null,
    currentTime: _I18n.default.moment().valueOf(),
    userTimezone: timezone,
    initTrackingForMeetings: initTrackingForMeetings,
    onSuccess: onSuccess,
    onFailure: onFailure,
    activeLocale: locale,
    forceMobile: forceMobile,
    parentPageHSAnalyticsInfo: parentPageHSAnalyticsInfo,
    troubleshooting: troubleshooting,
    forcePropertyForm: forcePropertyForm,
    allowTroubleshootMode: allowTroubleshootMode,
    allowRedirect: allowRedirect
  }, httpClient);

  if (disabledHsPopups) {
    var _window$disabledHsPop;

    if (!window.disabledHsPopups) {
      window.disabledHsPopups = [];
    }

    (_window$disabledHsPop = window.disabledHsPopups).push.apply(_window$disabledHsPop, (0, _toConsumableArray2.default)(disabledHsPopups));
  }

  return function (props) {
    return _react.default.createElement(_reactRedux.Provider, {
      store: store
    }, _react.default.createElement(_AppContainer.default, props));
  };
}

module.exports = exports.default;